import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';


@Component({
  selector: 'app-outward-approver',
  templateUrl: './outward-approver.component.html',
  styleUrls: ['./outward-approver.component.css']
})
export class OutwardApproverComponent implements OnInit {

  constructor(private appComponent: AppComponent) { }

  ngOnInit(): void {
  }

}
